var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9998 7.475C5.86647 7.475 5.73747 7.45 5.6128 7.4C5.48747 7.35 5.38314 7.28334 5.2998 7.2L0.699804 2.6C0.516471 2.41667 0.424805 2.18334 0.424805 1.9C0.424805 1.61667 0.516471 1.38334 0.699804 1.2C0.883138 1.01667 1.11647 0.925003 1.3998 0.925003C1.68314 0.925003 1.91647 1.01667 2.0998 1.2L5.9998 5.1L9.8998 1.2C10.0831 1.01667 10.3165 0.925003 10.5998 0.925003C10.8831 0.925003 11.1165 1.01667 11.2998 1.2C11.4831 1.38334 11.5748 1.61667 11.5748 1.9C11.5748 2.18334 11.4831 2.41667 11.2998 2.6L6.6998 7.2C6.5998 7.3 6.49147 7.37067 6.3748 7.412C6.25814 7.454 6.13314 7.475 5.9998 7.475Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.4958c660408ecbfcdbce61a32e319d38.svg";
export { ForwardRef as ReactComponent };